import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { AppLayout, MarketingLayout, PublicLayout } from "./components/Layouts";
import { AdminPage } from "./pages/admin/AdminPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { InvitationPage } from "./pages/auth/InvitationPage";
import { LoginPage } from "./pages/auth/LoginPage";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage";
import { ContactPage } from "./pages/ContactPage";
import { FauPublicPage } from "./pages/fau/FauPublicPage";
import { DpaPage, PrivacyPage } from "./pages/InfoPage";
import { ChangeDetailPage } from "./pages/kommune/ChangeDetailPage";
import { ChangesPage } from "./pages/kommune/ChangesPage";
import { DashboardPage } from "./pages/kommune/DashboardPage";
import { ExportsPage } from "./pages/kommune/ExportsPage";
import { FauAdminPage } from "./pages/kommune/FauAdminPage";
import { KommuneLayout } from "./pages/kommune/KommuneContext";
import { SchoolMapPage } from "./pages/kommune/SchoolMapPage";
import { TiltakPage } from "./pages/kommune/TiltakPage";
import { MembersPage } from "./pages/MembersPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { KommunePublicPage } from "./pages/public/KommunePublicPage";
import { KommunerPage } from "./pages/public/KommunerPage";
import { RootPage } from "./pages/RootPage";

/**
 * Route table. These URLs are a contract (e-mails link to /invitasjon/:token, /tilbakestill/:token
 * and the kommune pages), so change them only together with the backend templates.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/logg-inn" element={<LoginPage />} />
        <Route path="/invitasjon/:token" element={<InvitationPage />} />
        <Route path="/glemt-passord" element={<ForgotPasswordPage />} />
        <Route path="/tilbakestill/:token" element={<ResetPasswordPage />} />
        <Route path="/fau/:token" element={<FauPublicPage />} />
        <Route path="/personvern" element={<PrivacyPage />} />
        <Route path="/databehandling" element={<DpaPage />} />
      </Route>
      <Route element={<MarketingLayout />}>
        <Route path="/kommuner" element={<KommunerPage />} />
        <Route path="/kommuner/:nr" element={<KommunePublicPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
      </Route>
      <Route index element={<RootPage />} />
      <Route element={<AppLayout />}>
        <Route path="/o/:orgId/k/:nr" element={<KommuneLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="skoler/:schoolId" element={<SchoolMapPage />} />
          <Route path="tiltak" element={<TiltakPage />} />
          <Route path="endringer" element={<ChangesPage />} />
          <Route path="endringer/:changeId" element={<ChangeDetailPage />} />
          <Route path="eksport" element={<ExportsPage />} />
          <Route path="fau" element={<FauAdminPage />} />
        </Route>
        <Route path="/o/:orgId/medlemmer" element={<MembersPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
